import { Record } from "immutable";

export type SectionAggregationType = {
  averageScore?: number;
};

export const defaultSectionAggregation: SectionAggregationType = {
  averageScore: undefined
};

export default class SectionAggregation extends Record(
  defaultSectionAggregation
) {}
